let isSet = false;
export const ui = {};
export function set(uiToSet) {
    if (isSet) {
        cc.error('Trying to set ui twice.');
    }
    isSet = true;
    Object.assign(this.ui, uiToSet);

    if (!window.PSGames) {
        window.PSGames = {};
    }
    window.PSGames.CommonUI = this.ui;
}
